import { apiVariable } from "./apiVariable";
import {
  InvoiceSummary,
  InvoiceDetail,
  PayInvoiceRequest,
  AgingReportRequest,
} from "../interfaces/invoice";
import { saveAs } from "file-saver";

export const getInvoices = async (
  token: string | null | undefined,
  issuerId?: string,
  billToId?: string,
  onlyOpen?: boolean
): Promise<InvoiceSummary[]> => {
  const params = new URLSearchParams();
  if (issuerId) params.append("issuerId", issuerId);
  if (billToId) params.append("billToId", billToId);
  if (onlyOpen) params.append("onlyOpen", "true");

  const response = await fetch(`${apiVariable}/invoices?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) throw new Error("Failed to fetch invoices");
  return response.json();
};

export const getInvoice = async (
  token: string | null | undefined,
  id: string
): Promise<InvoiceDetail> => {
  const response = await fetch(`${apiVariable}/invoice/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) throw new Error("Failed to fetch invoice details");
  return response.json();
};

export const payInvoice = async (
  token: string | null | undefined,
  id: string,
  data: PayInvoiceRequest
): Promise<void> => {
  const response = await fetch(`${apiVariable}/invoice/${id}/pay`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error("Failed to pay invoice");
};

export const generateAgingReport = async (
  token: string | null | undefined,
  request: AgingReportRequest
): Promise<void> => {
  const params = new URLSearchParams();
  params.append("asOf", request.asOf);
  params.append("issuerId", request.issuerId);
  if (request.billToId) params.append("billToId", request.billToId);

  const response = await fetch(
    `${apiVariable}/aging/pdf?${params.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  if (!response.ok) throw new Error("Failed to generate aging report");

  const blob = await response.blob();
  const filename = `aging-${request.issuerId}-${
    request.asOf.split("T")[0]
  }.pdf`;
  saveAs(blob, filename);
};
